// Gráfico de telemetria (CPU/memória) isolado do App para reduzir o monolito.
export function TelemetryChart({
  points,
}: {
  points: Array<{ capturedAt: string; cpuPercent: number; memoryUsedPercent: number }>;
}) {
  if (!points.length) {
    return (
      <div className="empty">
        <b>Sem telemetria no período</b>
        <span>Os dados aparecem após o primeiro heartbeat do agente.</span>
      </div>
    );
  }
  const width = 720;
  const height = 220;
  const padLeft = 40;
  const padRight = 12;
  const padTop = 14;
  const padBottom = 26;
  const innerWidth = width - padLeft - padRight;
  const innerHeight = height - padTop - padBottom;
  const step = points.length > 1 ? innerWidth / (points.length - 1) : 0;
  const pointX = (index: number) => padLeft + (points.length > 1 ? index * step : innerWidth / 2);
  const pointY = (value: number) =>
    padTop + innerHeight - (Math.min(100, Math.max(0, value)) / 100) * innerHeight;
  const path = (key: "cpuPercent" | "memoryUsedPercent") =>
    points
      .map((point, index) => `${index ? "L" : "M"}${pointX(index).toFixed(1)},${pointY(point[key]).toFixed(1)}`)
      .join(" ");
  const areaPath = `${path("cpuPercent")} L${pointX(points.length - 1).toFixed(1)},${(padTop + innerHeight).toFixed(1)} L${pointX(0).toFixed(1)},${(padTop + innerHeight).toFixed(1)} Z`;
  const average = (key: "cpuPercent" | "memoryUsedPercent") =>
    points.reduce((total, point) => total + point[key], 0) / points.length;
  const timeLabel = (value: string) =>
    new Date(value).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
  const middle = points[Math.floor((points.length - 1) / 2)];
  const last = points[points.length - 1];
  return (
    <div className="telemetry-chart">
      <svg viewBox={`0 0 ${width} ${height}`} role="img" aria-label="Uso de CPU e memória no período">
        {[0, 25, 50, 75, 100].map((value) => (
          <g key={value}>
            <line
              className="chart-grid"
              x1={padLeft}
              x2={width - padRight}
              y1={pointY(value)}
              y2={pointY(value)}
            />
            <text className="chart-axis" x={padLeft - 8} y={pointY(value) + 4} textAnchor="end">
              {value}%
            </text>
          </g>
        ))}
        <path className="chart-area" d={areaPath} />
        <path className="chart-line memory" d={path("memoryUsedPercent")} />
        <path className="chart-line cpu" d={path("cpuPercent")} />
        <text className="chart-axis" x={padLeft} y={height - 8}>
          {timeLabel(points[0].capturedAt)}
        </text>
        <text className="chart-axis" x={padLeft + innerWidth / 2} y={height - 8} textAnchor="middle">
          {timeLabel(middle.capturedAt)}
        </text>
        <text className="chart-axis" x={width - padRight} y={height - 8} textAnchor="end">
          {timeLabel(last.capturedAt)}
        </text>
      </svg>
      <div className="chart-legend">
        <span>
          <i className="cpu" /> CPU {Math.round(last.cpuPercent)}% agora · média {Math.round(average("cpuPercent"))}%
        </span>
        <span>
          <i className="memory" /> Memória {Math.round(last.memoryUsedPercent)}% agora · média{" "}
          {Math.round(average("memoryUsedPercent"))}%
        </span>
      </div>
    </div>
  );
}
